const scope_0 = require('/opt/build/repo/.cache/gatsby-mdx/mdx-scopes-dir/8156c18eb84869e200bee0d293c38e17.js').default;
const scope_1 = require('/opt/build/repo/.cache/gatsby-mdx/mdx-scopes-dir/da81b17f327deb0a95d4c1bbf0aa7588.js').default;export default 
        Object.assign({}, scope_0,
scope_1 )
    